/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import VAR_COMMON_CONSTANTS from "../../../../constants/globalVariables"


export enum TREE_OPERATIONS_SWITCH_OPTIONS {
  EDIT_FOLDER = "editFolder",
  ADD_NEW_FOLDER = "addNewFolder",
  ADD_NEW_DATASET = "addNewDataset",
  EDIT_DATASET = "editDataset",
  DUPLICATE_DATASET = "duplicateDataset",
  DELETE = "delete",
  COPY_DATASET = "copyDataset",
  COPY_FOLDER = "copyFolder",
  PASTE_CONTENTS = "pasteContent",
  COPY_FOLDER_TO_STUDY = "copyFolderToStudy",
  COPY_DATASET_TO_STUDY = "copyDatasetToStudy"
}

const contextMenuRawFolder = [
  {name: "Edit", type: "editFolder"},
  {name: "New "+VAR_COMMON_CONSTANTS.VAR_DATA_SET, type: "addNewDataset"},
  {name: "New Folder", type: "addNewFolder"},
  {name: "Copy ", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_FOLDER},
  {name: "Paste ", type: TREE_OPERATIONS_SWITCH_OPTIONS.PASTE_CONTENTS},
  {name: "Copy to Study", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_FOLDER_TO_STUDY},
  {name: "Delete", type: "delete"},
];

const contextMenuRawDataset = [

  {name: "Edit ", type: "editDataset"},
  {name: "Duplicate ", type: "duplicateDataset"},
  {name: "Copy ", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_DATASET},
  {name: "Copy to Study", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_DATASET_TO_STUDY},
  {name: "Delete ", type: "delete"}
]
const contextMenuMergedFolder = [
  {name: "Delete Folder", type: "delete"},
]
const contextMenuMergeSet = [
  {name: "Delete", type: "delete"},
  {name: "Edit", type: "editMergeSet"},
]
const contextMenuMergedDataset = [
  {name: "Delete "+VAR_COMMON_CONSTANTS.VAR_DATA_SET, type: "delete"},
]
const contextMenuRawStudy = [
  {name: "New "+ VAR_COMMON_CONSTANTS.VAR_DATA_SET, type: "addNewDataset"},
  {name: "New "+VAR_COMMON_CONSTANTS.VAR_FOLDER, type: "addNewFolder"},
  {name: "Copy ", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_FOLDER},
  {name: "Paste", type: TREE_OPERATIONS_SWITCH_OPTIONS.PASTE_CONTENTS},
  {name: "Copy to Study", type: TREE_OPERATIONS_SWITCH_OPTIONS.COPY_FOLDER_TO_STUDY}
]

export enum TREE_OPERATIONS {
  ADD = "add", 
  EDIT_FOLDER = "editFolder",
  EDIT_DATASET = "editDataset", 
  DUPLICATE_DATASET = "duplicateDataset", 
  DELETE = "delete",
  EDIT = "edit",
  PASTE = 'paste',
  COPY_TO_STUDY = "Copy to Study",
  REORDER = "reorder",
}
export enum REDLINE_DIALOG_OPTIONS {
  EDIT_FOLDER = "editFolder",
  ADD_NEW_FOLDER = "addNewFolder",
  ADD_NEW_DATASET = "addNewDataset",
  EDIT_DATASET = "editDataset",
  EDIT_MERGE_SET = "editMergeSet",
  DUPLICATE_DATASET = "duplicateDataset",
  DELETE = "delete",
  ADD_PROPERTY = "addProperty", 
  EDIT_PROPERTY = "editProperty", 
  EDIT_ROW = "editRow", 
  DEL_CAT_GRP = "delCategoryGroup",
}

export enum EDatasetExecutionStatus {
  COMPLETED = "Completed", 
  IN_PROGRESS = "In Progress", 
  ABORTED = "Aborted", 
  NOT_STARTED = "Not Started", 
  INVALID_RESULTS = "Invalid Results",
  PENDING = "Pending",
  NOT_YET_TRACKED = "Not yet tracked",
  EMPTY = ""
}

export enum MERGE_MODES {
  CREATE = "create",
  UPDATE = "update"
}

const IN_PROGRESS_STATUSES: Set<EDatasetExecutionStatus | undefined> = new Set([EDatasetExecutionStatus.IN_PROGRESS, EDatasetExecutionStatus.PENDING])
const EXECUTION_STATUSES: Set<EDatasetExecutionStatus | undefined> = new Set([EDatasetExecutionStatus.IN_PROGRESS, EDatasetExecutionStatus.PENDING, EDatasetExecutionStatus.COMPLETED, EDatasetExecutionStatus.ABORTED, EDatasetExecutionStatus.NOT_STARTED, EDatasetExecutionStatus.INVALID_RESULTS])
const SINGLE_DATASET_TYPE_STR = "Single"
const MERGED_DATASET_TYPE_STR = "Merged"

const SINGLE_DATASET_TREE_TYPE = "Single"
const MERGED_DATASET_TREE_TYPE = "Merged"

const refreshTreeWithSanityCheck = "/HttpTriggerRefreshTreeWithDatasets"
const coverageRequirementsFetchData = "/HttpTriggerGetDataCoreSQL?container=CoverageRequirements"
const coverageRequirementsModifyTreeEndpoint = "/HttpTriggerCoverageModifyTree"
const coverageRequirementsCopyDataEndpoint = "/HttpTriggerCoverageRequirements?request_operation=update&request_type=copyData"
const coverageRequirementsCopyDataToStudyEndpoint = "/HttpTriggerCoverageRequirements?request_operation=update&request_type=copyToStudy"

const COVERAGE_REQUIREMENTS_STUDY_ID_URL_PARAM = "studyId"
const SELECTED_DATASET_ID_URL_PARAM = "datasetId"
const SELECTED_DATASET_TYPE_URL_PARAM = "datasetType"
const SELECTED_DATASET_NAME_URL_PARAM = "datasetName"
const COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_ONE_INDEX_URL_PARAM = "htabs-coverage_requirements-0-0"
const COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_ONE_NAME_URL_PARAM = "htabs-coverage_requirements-0-0-name"
const COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_TWO_INDEX_URL_PARAM = "htabs-coverage_requirements-0-1"
const COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_TWO_NAME_URL_PARAM = "htabs-coverage_requirements-0-1-name"

const KEY_NAME_SOURCE_DATASET = "source_dataset"
const KEY_NAME_REDLINE_TYPE = "redlineType"
const KEY_NAME_DRIVING_SCENARIO_PROPERTIES = "driving_scenario_properties"
const KEY_NAME_DRIVING_SCENARIO_DESIGN_EXPERIMENTS = "driving_scenario_design_experiments"
const KEY_NAME_DOE_TABLE = "doe_table"


export const nextToColumnOnTabMap: any =  {
  "min" : "max", 
  "max" : "totalSteps", 
  "totalSteps" : "rationale",
  "rationale": "min",
}
export {
  coverageRequirementsFetchData,
  coverageRequirementsModifyTreeEndpoint,
  contextMenuRawFolder,
  contextMenuRawDataset,
  contextMenuMergedFolder,
  contextMenuMergeSet,
  contextMenuMergedDataset,
  contextMenuRawStudy,
  refreshTreeWithSanityCheck,
  coverageRequirementsCopyDataEndpoint,
  coverageRequirementsCopyDataToStudyEndpoint,

  SINGLE_DATASET_TYPE_STR,
  MERGED_DATASET_TYPE_STR,
  SINGLE_DATASET_TREE_TYPE,
  MERGED_DATASET_TREE_TYPE,

  COVERAGE_REQUIREMENTS_STUDY_ID_URL_PARAM,
  SELECTED_DATASET_ID_URL_PARAM,
  SELECTED_DATASET_TYPE_URL_PARAM,
  SELECTED_DATASET_NAME_URL_PARAM,

  COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_ONE_INDEX_URL_PARAM,
  COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_ONE_NAME_URL_PARAM,
  COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_TWO_INDEX_URL_PARAM,
  COVERAGE_REQUIREMENTS_HORIZONTAL_TABS_TWO_NAME_URL_PARAM,

  KEY_NAME_SOURCE_DATASET,
  KEY_NAME_REDLINE_TYPE,
  KEY_NAME_DRIVING_SCENARIO_PROPERTIES,
  KEY_NAME_DRIVING_SCENARIO_DESIGN_EXPERIMENTS,
  KEY_NAME_DOE_TABLE,

  IN_PROGRESS_STATUSES,
  EXECUTION_STATUSES
}